import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from 'components/Navigation';
import * as S from './ChangePasswordComplete.styled';
import doneIcon from 'assets/MypageImage/done.png';

function ChangePasswordComplete() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // 비밀번호 변경 완료 후에는 계정 관리 페이지로 이동
    navigate('/account-management');
  };

  return (
    <S.Body>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        비밀번호 변경
      </S.Header>

      <S.ContentWrap>
        <S.IconContainer>
          <S.DoneIcon src={doneIcon} alt="완료" />
        </S.IconContainer>

        <S.Message>비밀번호 변경이 완료되었습니다!</S.Message>
      </S.ContentWrap>

      <NavigationBar />
    </S.Body>
  );
}

export default ChangePasswordComplete;
